import { render, staticRenderFns } from "./SalaryHome.vue?vue&type=template&id=2f7166f0&scoped=true&"
import script from "./SalaryHome.vue?vue&type=script&lang=js&"
export * from "./SalaryHome.vue?vue&type=script&lang=js&"
import style0 from "./SalaryHome.vue?vue&type=style&index=0&id=2f7166f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7166f0",
  null
  
)

export default component.exports